module.exports = __webpack_public_path__ + "static/media/w-12.e12cc6b5.jpg";